
define('app/dashboard/purchase/purchaseMain',[
	'domReady',
	'app/dashboard/purchase/purchaseApp',
	'app/common/setup'
], function(domReady, PurchaseApp, Setup){
	domReady(function () {
		Setup.initialize();
		PurchaseApp.initialize();
    });
});